/* import __COLOCATED_TEMPLATE__ from './add-tag-to-conversation.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { captureException } from 'embercom/lib/sentry';

interface Arguments {
  action: any;
}

export default class AddTagToConversationAction extends Component<Arguments> {
  @service declare appService: AppService;

  get actionTagName() {
    let tagId = this.args.action.actionData.tag_id;

    if (!tagId) {
      return '';
    }

    let tag = this.appService.app.tags.findBy('id', tagId);

    if (!tag) {
      captureException(new Error('Unable to find corresponding tag for tag conversation action'));
      return '';
    }
    return tag.name;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::ApplyRules::Actions::AddTagToConversation': typeof AddTagToConversationAction;
    'workflows/graph-editor/node-items/steps/apply-rules/actions/add-tag-to-conversation': typeof AddTagToConversationAction;
  }
}
